<div [@routeAnimations]="getRouteAnimationData()">
    <router-outlet></router-outlet>
</div>
